import React from 'react';
import { render } from 'react-dom';
import Dropdown from './src/loadable-dropdown';

window.initAddEventToCalendarDropDown = (event, domNodeId) => render(
  <Dropdown {...event} />,
  document.getElementById(domNodeId)
);